import { LOGIN_PAGE } from 'constants/pages'
import { selectResetPasswordToken } from 'selectors/account'
import {
  doChangePasswordWithResetToken as doChangePasswordWithResetTokenAction,
  doLoadResetPasswordRequest as doLoadResetPasswordRequestAction,
} from 'actions/account'

export function doChangePasswordWithResetToken(params) {
  return (dispatch, getState) => {
    const state = getState()
    const resetToken = selectResetPasswordToken(state)

    return doChangePasswordWithResetTokenAction(
      resetToken,
      params.passwordInput,
      params.passwordConfirmInput,
      params.twoFactorAuthenticationInput
    )(dispatch, getState).then(({ valid = false } = {}) => {
      if (valid) {
        dispatch({ type: LOGIN_PAGE })
      }
    })
  }
}

export function doLoadResetPasswordRequest() {
  return (dispatch, getState) => {
    const state = getState()
    const resetToken = selectResetPasswordToken(state)
    return doLoadResetPasswordRequestAction(resetToken)(dispatch, getState)
  }
}
